import { SkeletonRow } from '../skeleton';

// Complete header skeleton that matches the full header structure
const HeaderSkeleton = () => (
  <nav className='flex min-h-25 w-full flex-col items-center bg-white py-4 pb-0 shadow-md xl:pb-4'>
    <div className='grid w-full max-w-7xl auto-rows-min grid-cols-2 xl:mt-0 xl:mb-0 xl:grid-flow-col xl:grid-cols-[auto_auto_min-content] xl:grid-rows-1'>
      {/* Logo skeleton */}
      <div className='flex items-center border-b border-gray-200 pb-2 pl-3 xl:border-b-0 xl:pb-0'>
        <SkeletonRow className='h-5 w-32 md:h-6' />
      </div>

      {/* Buttons skeleton */}
      <div className='mx-0 flex min-h-11 justify-end border-b border-gray-200 pr-3 pb-2 xl:col-start-3 xl:mx-3 xl:border-b-0 xl:pr-0 xl:pb-0'>
        <div className='flex min-h-10 min-w-23 flex-row items-center justify-end space-x-1.5 md:min-w-26 md:space-x-2'>
          <SkeletonRow className='h-5 w-20 md:h-6 md:w-24 lg:w-32' />
          <SkeletonRow className='h-5 w-20 md:h-6 md:w-24 lg:w-32' />
        </div>
      </div>

      {/* Navigation links skeleton */}
      <div className='z-50 col-span-2 flex w-full items-center justify-center overflow-x-auto shadow-md md:shadow-none xl:col-span-1 xl:justify-end'>
        <div className='flex max-w-156 flex-row justify-center gap-8 overflow-x-auto scroll-smooth px-9 py-4 whitespace-nowrap xl:justify-end'>
          <SkeletonRow className='h-5 min-w-28 md:h-6' />
          <SkeletonRow className='h-5 min-w-28 md:h-6' />
          <SkeletonRow className='h-5 min-w-28 md:h-6' />
          <SkeletonRow className='h-5 min-w-28 md:h-6' />
        </div>
      </div>
    </div>
  </nav>
);

export default HeaderSkeleton;
